import css from './NewPage.module.scss'


import React from 'react'

const Avto = () => {
  return (
      <>
          <p className={css.text}>
             Свідоцтво про реєстрацію транспортного засобу (з відміткою про зняття з обліку);
Експертна оцінка ринкової вартості транспортного засобу, замовлена у цілях оподаткування із ідентифікатором у базі ФДМУ. 
          </p>
       <h2 className={css.title}>Сторона фізична особа:</h2>
            
                    <p className={css.text}>
Паспорт (звертаємо Вашу увагу на наявність в паспорті вклеєних фотографій при досягненні особою 25-річного або 45-річного віку);                   </p>
               
                    <p className={css.text}>
Реєстраційний номер облікової картки платника податків;                   </p>
               
                    <p className={css.text}>
Якщо фізична особа в шлюбі – згода подружжя на укладення договору див. Згода одного з подружжя на відчуження або придбання майна.                   </p>
                <h2 className={css.title}>Сторона юридична особа:</h2>
    <p className={css.text}>
            Виписка з Єдиного державного реєстру юридичних осіб та фізичних осіб-підприємців (свідоцтво про державну реєстрацію);</p>
           <p className={css.text}>
             Витяг з Єдиного державного реєстру юридичних осіб та фізичних осіб-підприємців (місячної давності);</p>
           <p className={css.text}>
             Статут;</p>
           <p className={css.text}>
             Довідка з ЄДРПОУ (видається органами статистики);</p>
           <p className={css.text}>
             Протокол/рішення, наказ про призначення посадової особи, яка уповноважена за статутом діяти без довіреності;</p>
           <p className={css.text}>
Якщо від імені юридичної особи діє представник, уповноважений за довіреністю – посвідчена нотаріально довіреність;</p>
    <p className={css.text}>
              Якщо діє від імені юридичної особи керівник філії (відділення) – додатково аналогічний перелік документів по філії (відділенню);</p>
          <p className={css.text}>
              Якщо укладення такого характеру договорів згідно статуту юридичної особи здійснюється зі згоди вищого органу – протокол загальних зборів вищого органу, в якому представнику юридичної особи надано згоду на укладення договору;</p>
          <p className={css.text}>
              Паспорт підписанта;</p>
          <p className={css.text}>
              Печатка юридичної особи.</p>
          
      </>
  )
}

export default Avto
